<template>

  <div class="jumbotron">
    <div style="max-width: 820px;">
      <h1 class="display-4" style="font-size: 2.8rem;"><i class="fa-solid fa-lock"></i> Limite de vagas abertas alcançado!</h1>
      <p class="lead">Seu plano possui um limite de X vagas abertas simultâneas. Para abrir uma nova vaga, é necessário arquivar uma das vagas existentes ou fazer um upgrade do seu plano.</p>
      <hr class="my-4">
      <h5>Como expandir o limite?</h5>
      <p>Se você expandir o limite de vagas abertas simultâneas, entre em contato conosco para saber mais sobre as opções de upgrade.</p>
      <a class="btn btn-primary btn-lg mt-3" href="#" role="button">Fale agora conosco</a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Unavailable',
  components: {
  },
  props: {
    title: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  metaInfo () {
    return {
      title: this.$t('Requisitions')
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Unavailable/UnavailableJob.vue